import { rethrowError } from 'UIComponents/core/PromiseHandlers';
import { registerQuery, useQuery } from 'data-fetching-client';
import { fetchDashboards } from '../api/dashboard';
import { CREATE_DASHBOARD_LINK, GROSS_PAYMENT_DASHBOARD_LINK } from '../utils/constants';
export const GET_DASHBOARD_INFO = registerQuery({
  fieldName: 'dashboardInfo',
  fetcher: fetchDashboards
});
export function useGetGrossPaymentLink() {
  const {
    data,
    loading,
    error
  } = useQuery(GET_DASHBOARD_INFO);
  if (error) {
    rethrowError(error);
  }
  if (loading || !data || data.dashboardInfo.dashboards.length === 0) {
    return {
      loading,
      link: CREATE_DASHBOARD_LINK
    };
  }
  const dashboards = data.dashboardInfo.dashboards.filter(a => a.template === 'gross-payment-revenue' && a.active);
  if (dashboards.length === 0) {
    return {
      loading,
      link: CREATE_DASHBOARD_LINK
    };
  }
  const dashboard = dashboards.sort((a, b) => b.updatedAt - a.updatedAt)[0];
  return {
    loading,
    link: `${GROSS_PAYMENT_DASHBOARD_LINK}${dashboard.id}`
  };
}